import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';

export const GoToMainContent: FC = () => {
  const texts = useTexts();

  const handleOnClick = (): void => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
    }
  };

  return (
    <Wrapper>
      <Button variant="tertiary" onClick={handleOnClick}>
        {texts.application.goToMainContent}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;

  &:focus-within {
    position: relative;
  }

  @media print {
    display: none;
  }
`;
